/**
 * 개인정보 처리방침 화면. URL `/privacy`.
 *
 * 로그인 여부와 무관하게 열람 가능한 공개 페이지다. 랜딩·회원가입 등에서 링크로 들어오고,
 * "홈으로" 버튼으로 `/`로 돌아간다. 본문은 API가 아니라 `@/constants/terms`의
 * `PRIVACY_POLICY` 상수(코드에 하드코딩된 약관 텍스트)를 그대로 렌더한다. 문구 수정은
 * 이 파일이 아니라 `src/constants/terms.ts`를 고치고 배포해야 반영된다.
 */
import React from "react";
import Head from "next/head";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { PRIVACY_POLICY } from "@/constants/terms";

import Link from "next/link";

/** 약관 본문을 그대로 출력하는 정적 화면. */
const Privacy = () => {
  return (
    <div className="bg-page min-h-screen flex flex-col">
      <Head>
        <title>개인정보 처리방침 | 해봄</title>
      </Head>
      <Header />
      <main className="flex-grow flex justify-center py-10 md:py-20 px-4 md:px-6">
        <div className="max-w-[900px] w-full bg-white rounded-[24px] p-8 md:p-16 shadow-[0_4px_24px_rgba(0,0,0,0.04)]">
          <div className="flex items-center justify-between mb-10 pb-6 border-b border-line-subtle">
            <h1 className="text-24 md:text-32 font-bold text-heading font-heading">
              개인정보 처리방침
            </h1>
            <Link 
              href="/"
              className="px-6 py-2 rounded-full border border-line text-14 text-muted hover:bg-page hover:text-primary transition-all"
            >
              홈으로
            </Link>
          </div>
          
          <div className="bg-page rounded-[16px] p-6 md:p-10">
            <div className="text-15 md:text-16 text-strong font-normal whitespace-pre-wrap leading-[1.8] tracking-[-0.01em]">
              {PRIVACY_POLICY}
            </div>
          </div>
          
          <div className="mt-12 text-center text-14 text-disabled">
            본 방침은 2026.03.09부터 적용됩니다.
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Privacy;
